// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'
import { isoDateSchema } from '../_shared/primitives'
import { authSuccessSchema } from './me'

/** Sessão de refresh token (família). Documenta GET /auth/sessions — comportamento inalterado nesta fase. */
export const sessionSchema = z.object({
  id: z.number(),
  family_id: z.string(),
  device_fingerprint: z.string(),
  ip_address: z.string(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
  expires_at: isoDateSchema,
  is_current: z.boolean(),
})
export type Session = z.infer<typeof sessionSchema>

export const sessionsResponseSchema = z.array(sessionSchema)
export const logoutResponseSchema = z.object({ message: z.string() })

/** POST /auth/refresh devolve o mesmo envelope de login. */
export const refreshResponseSchema = authSuccessSchema
